<template>
  <div :class="{container:!isIE, 'container-ie':isIE}"  >

    <div :class="{'back-ie':isIE, wh100:true}" layout="column center-center">

      <img :class="{'image-back':true, 'image-rotation':!isIE}" src="/static/images/keyvisual-back.png" srcset="/static/images/keyvisual-back@2x.png 2x"/>
      <img v-if="!isIE" class="image-energy" src="/static/images/energy-cloud.png" srcset="/static/images/energy-cloud@2x.png 2x"/>
      <img :class="{'image-overlay':true, 'image-overlay-ie':isIE}" src="/static/images/keyvisual-overlay.png" srcset="/static/images/keyvisual-overlay@2x.png 2x"/>
      <img v-if="!isIE" class="image-energy-small" src="/static/images/energy-cloud.png" srcset="/static/images/energy-cloud@2x.png 2x"/>
      <div :class="{'container-text':true, 'container-text-ie':isIE, 'pointer':link != null}" layout="column center-center" @click="click()">
        <div ref="textClaim" class="text-claim" v-html="claimText">maximal</div>
        <span ref="textInfo" class="text-info" v-html="infoText"></span>
      </div>
      <countdown v-if="!isIE && showCountdown" ref="countdown" class="countdown" :startDate="startDate" :date="targetDate" @complete="onCountdownComplete"/>
    </div>
    <countdown v-if="isIE && showCountdown" ref="countdown" class="countdown" :startDate="startDate" :date="targetDate" @complete="onCountdownComplete"/>
  </div>
</template>
<script>

  import Countdown from "./Countdown";
  import BackendProxy from "@/BackendProxy";
  import detect from 'detect-browser';

  export default {
    components: {Countdown},
    name: "key-visual",
    props: ['value', 'claim1', 'claim2', 'claim3'],
    data() {
      return {
        targetDate: new Date(),
        startDate: new Date(),
        // isIE: detect.detect().name == 'ie' || ((navigator.userAgent || navigator.vendor || window.opera).toLowerCase().indexOf('instagram') != -1),
        isIE: false,
        showCountdown: true,
        claimText: '',
        infoText: '',
        link: null
      }
    },
    methods: {

      onCountdownComplete() {
        setTimeout(() => {
          this.updateValues();
        }, 1000);
      },

      click() {
        if (this.link) this.$router.push(this.link);
      },

      updateValues() {

        const now = Date.now();

        // const date = new Date(2018, 4, 10, 23, 59, 58);
        // const now = date.getTime();
        // this.startDate = date;

        const activeCity = BackendProxy.instance.getActiveCity(now);
        const nextCity = BackendProxy.instance.getNextActiveCity(now);

        const backend = BackendProxy.instance;

        console.log(nextCity);

        try {
          this.infoText = this.value.split('\n').join('<br>');
        } catch (e) {
        }

        if (activeCity == null) {

          this.showCountdown = true;

          if (now < backend.startDate.getTime()) {

            //vor event generell
            try {
              this.claimText = this.claim1.split('\n').join('<br>');
            } catch (e) {

            }

            this.targetDate = backend.startDate;

          } else {

            if (nextCity) {
              try {
                //vor nächstem event
                this.claimText = this.claim3
                  .split('\n')
                  .join('<br>')
                  .replace('#city#', nextCity.name);
                this.link = `/${nextCity.key}`;
              } catch (e) {
              }


              this.targetDate = nextCity.startDateJS;
            }
            else {
              //aktion vorbei
              this.showCountdown = false;
              this.claimText = '';
            }
          }

        } else {
          //stadt aktiv
          this.showCountdown = false;
          this.claimText = this.claim2
            .split('\n')
            .join('<br>')
            .replace('#city#', activeCity.name);
          this.link = `/${activeCity.key}`;

        }
        this.$refs.countdown.updateDate();
      }

    },
    mounted() {
      this.updateValues();
      this.isIE = (detect.detect().name == 'ie');
    }
  }
</script>

<style lang="scss" scoped>

  $max-width: 1200px;
  $min-width: 400px;

  .container {
    /*// pointer-events: none;*/
    position: relative;
    width: 100%;
    height: 80vw;
    margin: 0;
    padding: 0;
    max-height: 900px;
    min-height: 300px;
    margin-bottom: -5vw;
    /*overflow: hidden;*/

    /*background-color: yellow;*/

    @media screen and (min-width: $max-width) {
      margin-top: 30px;
      margin-bottom: 0px;
    }

    @media screen and (min-width: $max-width) {
      margin-bottom: -30px;
    }
  }

  .back-ie {
    display: block;
  }

  .container-ie {
    position: relative;
    width: 100%;
    height: 80vw;
    margin: 0;
    margin-top: -10vw;
    padding: 0;
    max-height: 900px;
    min-height: 300px;

    margin-bottom: -15vw;

    @media screen and (min-width: $max-width) {
      margin-top: -150px;
      margin-bottom: -100px;
    }

    @media screen and (max-width: 640px) {
      margin-top: -90px;
    }
  }

  .pointer {
    cursor: pointer;
  }

  .countdown {
    position: absolute !important;
    top: -8vw;
    @media screen and (min-width: $max-width) {
      top: -90px;
    }
  }

  $time: 800s;
  .image-back {
    position: absolute;
    max-width: 1000px;
    width: 100%;
    z-index: -1;
    /* mix-blend-mode: color-dodge;*/
    /*left:0px;*/
    /*top:0px;*/
    /*background-color: red;*/

    @media screen and (max-width: $min-width) {
      /*width: 120%;*/
    }
  }

  .image-rotation {

    -webkit-animation: spin $time linear infinite;
    -moz-animation: spin $time linear infinite;
    animation: spin $time linear infinite;
  }

  $time: 15s;
  .image-energy {
    position: absolute;
    /*left:0px;*/
    /*top:0px;*/
    max-width: 1000px;
    width: 100%;
    mix-blend-mode: color-dodge;
    opacity: 0.9;

    display: block;
    -webkit-animation: spin $time linear infinite;
    -moz-animation: spin $time linear infinite;
    animation: spin $time linear infinite;
  }

  $time: 20s;
  .image-energy-small {
    position: absolute;
    max-width: 1000px;
    width: 80%;
    mix-blend-mode: color-dodge;
    opacity: 0.7;
    /*left:0px;*/
    /*top:0px;*/
    -webkit-animation: spin-back $time linear infinite;
    -moz-animation: spin-back $time linear infinite;
    animation: spin-back $time linear infinite;
    @media screen and (max-width: $min-width) {
      display: none;
    }
  }

  @keyframes spin {
    to {
      -webkit-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }

  @keyframes spin-back {
    from {
      -webkit-transform: rotate(360deg);
      transform: rotate(360deg);
    }

    to {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
    }

  }

  .image-overlay {
    position: absolute;
    max-width: 1000px;
    width: 100%;
    /*background-color: yellow;*/
    /*left:0px;*/
    /*top:0px;*/
    @media screen and (max-width: $min-width) {
      /*width: 120%;*/
    }
  }

  .image-overlay-ie {

    /*position: absolute;*/
    top: 0px;
    left: 0px;
    @media screen and (min-width: $max-width) {

    }

    @media screen and (max-width: 640px) {
      // margin-top:-90px;
    }
  }

  .container-text {
    position: absolute;
  }

  .container-text-ie {
    top: 21vw;
    left: 1vw;
    @media screen and (min-width: $max-width) {
      top: 250px;
    }
  }

  .text-claim {
    font-size: 6vw;
    font-weight: 400;
    line-height: 6vw;
    /*letter-spacing: 0.1vw;*/
    margin-top: 3vw;
    text-align: center;
    text-shadow: 0.4vw 0.4vw 10px rgba(0, 0, 0, 0.8);
    width: 100vw;

    @media screen and (min-width: $max-width) {
      font-size: 70px;
      line-height: 80px;
      text-shadow: 5px 5px 10px rgba(0, 0, 0, 0.8);
    }

    @media screen and (max-width: $min-width) {
      font-size: 28px;
      line-height: 28px;
    }
  }

  .text-info {
    width: 72vw;
    font-weight: 400;
    margin-top: 1.3vw;
    font-size: 3.1vw;
    padding: 3px;
    text-shadow: 0.1vw 0.1vw 3px rgba(0, 0, 0, 0.8);
    text-align: center;

    background-color: rgba(0, 0, 0, 0.2);
    /*background-color: red;*/

    @media screen and (min-width: $max-width) {
      font-size: 40px;
      line-height: 40px;
      width: 900px;
      text-shadow: 2px 2px 3px rgba(0, 0, 0, 0.8);
    }
    @media screen and (max-width: $min-width) {
      font-size: 16px;
      line-height: 18px;
      width: 400px;
    }
  }

  .back {
    max-width: 1000px;

    width: 100%;
    height: 100%;
    overflow: hidden;
  }

</style>



// WEBPACK FOOTER //
// src/components/blocks/KeyVisual.vue